import { generatePath } from 'react-router'
import { ROUTES } from 'constants/routes'

export default function ({
  i18n,
  result_params,
  networkType = '',
  method = undefined,
}) {
  const { payment_order_id, account_id, wallet_id, payment_profile_id } =
    result_params

  if (payment_order_id) {
    return generatePath(ROUTES.PAYMENT_ORDER, {
      i18n,
      id: payment_order_id,
    })
  }

  if (account_id) {
    return generatePath(ROUTES.SERVICES_NETWORK_ACCOUNT, {
      i18n,
      networkType,
      accountId: account_id,
    })
  }

  if (payment_profile_id && method === 'cashless') {
    return generatePath(ROUTES.FINANCE_PAYMENT_PROFILE_INVOICES, {
      i18n,
      profileId: payment_profile_id,
    })
  }

  if (wallet_id) {
    return generatePath(ROUTES.FINANCE_WALLET, {
      i18n,
      walletID: wallet_id,
    })
  }
}
